import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'

import { applyGeoFilterAndNavigate } from '@/pages/klienci/common/klienciFiltersStorage'
import useTypyPlacowekData from './hooks/useTypyPlacowekData'
import useTypyPlacowekModal from './hooks/useTypyPlacowekModal'
import SearchActionsBar from '@/widgets/SearchActionsBar'
import LoadMoreSection from '@/widgets/LoadMoreSection'
import TypyPlacowekTable from './components/TypyPlacowekTable'
import TypPlacowkiModal from './components/TypPlacowkiModal'

export default function TypyPlacowek() {
	const navigate = useNavigate()

	const {
		data,
		loading,
		loadingMore,
		error,
		totalCount,
		hasMore,
		loadData,
		handleLoadMore,
		setSorting,
		updateFilters,
		sortColumn,
		sortDirection,
		searchQuery,
		clearError,
	} = useTypyPlacowekData()

	const {
		isModalOpen,
		editingItem,
		formType,
		setFormType,
		isSaving,
		openEditModal,
		handleDelete,
		closeModal,
		handleSubmit,
		buttons,
	} = useTypyPlacowekModal(loadData)

	useEffect(() => {
		if (error) {
			Swal.fire({
				title: 'Error',
				text: error,
				icon: 'error',
			}).then(() => {
				clearError()
			})
		}
	}, [error, clearError])

	useEffect(() => {
		loadData()
	}, [loadData])

	const handleSort = column => {
		const newDirection = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc'
		setSorting(column, newDirection)
	}

	const handleSearchChange = e => {
		updateFilters({ searchText: e.target.value })
	}

	const handleTypClick = typId =>
		applyGeoFilterAndNavigate(navigate, {
			targetPageKey: 'placowki',
			path: '/klienci/placowki',
			filterKey: 'id_typ',
			filterValue: typId,
		})

	return (
		<>
			<SearchActionsBar
				value={searchQuery}
				onChange={handleSearchChange}
				placeholder="Szukaj typow placowek po nazwie..."
				buttons={buttons}
			/>

			<TypyPlacowekTable
				data={data}
				loading={loading}
				sortColumn={sortColumn}
				sortDirection={sortDirection}
				onSort={handleSort}
				onEdit={openEditModal}
				onDelete={handleDelete}
				onTypClick={handleTypClick}
			/>

			<LoadMoreSection
				hasMore={hasMore}
				loadingMore={loadingMore}
				onLoadMore={handleLoadMore}
				dataLength={data.length}
				totalCount={totalCount}
			/>
			<TypPlacowkiModal
				isOpen={isModalOpen}
				editingItem={editingItem}
				formType={formType}
				setFormType={setFormType}
				isSaving={isSaving}
				onClose={closeModal}
				onSubmit={handleSubmit}
			/>
		</>
	)
}
